export function getPlain<T = any>(state: State | T): T {
  if (!state) return state
  return state instanceof Object && 'toJS' in state ? state.toJS() : state
}

// NOW shops carry `isInEU` in `shop.attributes`; the top-level field is only a fallback.
export function selectIsInEU(state: State): boolean {
  const shop = state.get('shop')
  if (!shop) return false
  const fromAttribute = shop
    .get('attributes', [])
    .find((attribute: ImmutableMap) => attribute.get('name') === 'isInEU')
    ?.get('value')
  return Boolean(fromAttribute ?? shop.get('isInEU'))
}
